// @ts-nocheck
import { Header } from './Header';
import { Footer } from './Footer';

/**
 * Header, main, Footer. Every route renders this and nothing else renders
 * Header or Footer directly.
 *
 * It exists because of the skip link. Header emits `<a href="#main-content">`
 * as the document's first focusable element, and before this the `<main>` it
 * points at was declared by hand in LandingPage only. So on the other
 * twenty-one routes the site's first tab stop went nowhere. Fifteen files each
 * opened with the same
 *
 *   <YStack backgroundColor="$background" minHeight="100vh">
 *     <Header />
 *
 * and closed with the matching `<Footer />`, which is a layout component
 * spelled out fifteen times.
 *
 * `flex={1}` on the main element matters: three of those pages have a body with
 * `flex={1}` of its own, which is what pushes the footer to the bottom of a
 * short page. Interposing a wrapper without it would have left those pages
 * with the footer floating mid-viewport.
 */
export function PageShell({ children }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--bg)',
        color: 'var(--ink)',
      }}
    >
      <Header />
      <main id="main-content" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
